import React from "react";
interface Props {
  memberData: any;
}
const PersonalInformation = ({ memberData }: Props) => {
  return (
    <div className="">
      <div className="my-8 grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            First Name
          </span>
          <span className="text-xs text-tertiaryText">
            {memberData?.firstName || "-"}
          </span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Last Name
          </span>
          <span className="text-xs text-tertiaryText">
            {memberData?.lastName || "-"}
          </span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Date of Birth
          </span>
          <span className="text-xs text-tertiaryText">
            {memberData?.dob || "-"}
          </span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">Email</span>
          <span className="text-xs break-words text-tertiaryText">
            {memberData?.email || "-"}
          </span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">Gender</span>
          <span className="text-xs text-tertiaryText">
            {memberData?.gender || "-"}
          </span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Phone Number
          </span>
          <span className="text-xs text-tertiaryText">
            {memberData?.phone || "-"}
          </span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Address
          </span>
          <span className="text-xs text-tertiaryText">
            {memberData?.address || "-"}
          </span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Languages
          </span>
          <div className="flex gap-2">
            <span className="text-xs bg-gray-200 px-2 py-1 rounded">
              {memberData?.language || "-"}
            </span>
          </div>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">City</span>
          <span className="text-xs text-tertiaryText">
            {memberData?.city || "-"}
          </span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">State</span>
          <span className="text-xs text-tertiaryText">
            {memberData?.state || "-"}
          </span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Zip Code
          </span>
          <span className="text-xs text-tertiaryText">
            {memberData?.zipCode || "-"}
          </span>
        </div>
      </div>
      {/* <div className=" my-6">
        <h1 className="text-base font-bold text-primaryText">Referral</h1>
        <div className="mt-4 flex flex-wrap sm:gap-40 items-center gap-4">
          <div className="flex flex-col gap-4">
            <span className="flex gap-3 items-center">
              <img
                className="w-10 h-10 rounded-full"
                src={dummyImage}
                alt="dummyImage"
              />
              <p className="text-base font-bold text-primaryText">
                Bertha Valdez
              </p>
            </span>
            <span className="text-xs text-tertiaryText">ID: HM-2122222</span>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default PersonalInformation;
